WW.fancybox = function($) {
    'use strict';

    $('.fancybox-thumb').fancybox({
        prevEffect	: 'none',
        nextEffect	: 'none',
        helpers: {
            media: true
        }

    });

    return this;
};
